export default __webpack_public_path__ + "static/media/food4.b609761d.jpg";